import { useEffect, useState } from "react";

const API = process.env.REACT_APP_BACKEND_URL;

export const useApi = (path) => {
    const [state, setState] = useState({ data: null, loading: true, error: false });
    useEffect(() => {
        let live = true;
        setState({ data: null, loading: true, error: false });
        fetch(`${API}/api/dashboard/${path}`)
            .then((r) => {
                if (!r.ok) throw new Error("request failed");
                return r.json();
            })
            .then((data) => live && setState({ data, loading: false, error: false }))
            .catch(() => live && setState({ data: null, loading: false, error: true }));
        return () => {
            live = false;
        };
    }, [path]);
    return state;
};

export const shortWallet = (w) => (w ? `${w.slice(0, 6)}...${w.slice(-4)}` : "");

export const usd = (n, digits = 2) =>
    `$${Number(n).toLocaleString("en-US", { minimumFractionDigits: digits, maximumFractionDigits: digits })}`;
